// extracted by mini-css-extract-plugin
module.exports = {"ButtonPublished":"CommunicationPublishButtons_ButtonPublished__6Au7a","ButtonUnpublished":"CommunicationPublishButtons_ButtonUnpublished__1xlyo"};